import { Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CountryRestrictionService } from '@app/country-restriction/country-restriction.service';
import { CountryRegistrationRestrictionService } from '@app/country-restriction/country-registration-restriction.service';
import { AuthenticationService } from '@app/core';
import { AppService } from '@app/core/app.service';
import { filter, map, mergeMap } from 'rxjs/operators';
var TemplateComponent = /** @class */ (function () {
    function TemplateComponent(countryRestrictionService, countryRegistrationRestrictionService, router, renderer, activatedRoute, auth, appService) {
        var _this = this;
        this.countryRestrictionService = countryRestrictionService;
        this.countryRegistrationRestrictionService = countryRegistrationRestrictionService;
        this.router = router;
        this.renderer = renderer;
        this.activatedRoute = activatedRoute;
        this.auth = auth;
        this.appService = appService;
        this.chatVisibility$ = null;
        this.classList = [];
        this.scrollTop = '';
        this.showFooterInCustom = false;
        this.showHero = false;
        this.showSubHeader = true;
        this.usesCustomTemplate = false;
        this.class = '';
        var onNavigationEnd = this.router.events.pipe(filter(function (event) { return event instanceof NavigationEnd; }));
        onNavigationEnd
            .pipe(map(function () {
            var route = _this.activatedRoute;
            while (route.firstChild) {
                route = route.firstChild;
            }
            return route;
        }), filter(function (route) { return route.outlet === 'primary'; }), mergeMap(function (route) { return route.data; }))
            .subscribe(function (event) {
            var hero = event['hero'];
            var subHeader = event['subHeader'];
            _this.showFooterInCustom = !!event['showFooterInCustom'];
            if (event['classList']) {
                _this.classList = event['classList'];
            }
            else {
                _this.classList = [];
            }
            _this.usesCustomTemplate = _this.appService.getFlag('customTemplate');
        });
    }
    Object.defineProperty(TemplateComponent.prototype, "hostClasses", {
        get: function () {
            return [
                this.class,
                this.showHero ? 'hero-image-margin' : '',
                this.showSubHeader ? 'sub-header-margin' : '',
                this.usesCustomTemplate ? 'custom-template' : ''
            ].concat(this.classList).join(' ');
        },
        enumerable: true,
        configurable: true
    });
    TemplateComponent.prototype.ngOnInit = function () {
        this.trackRouterChanges();
    };
    TemplateComponent.prototype.ngOnDestroy = function () {
        if (this._routerSub) {
            this._routerSub.unsubscribe();
        }
        if (this.chatVisibility$) {
            this.chatVisibility$.unsubscribe();
        }
    };
    TemplateComponent.prototype.useCustomTemplate = function () {
        return this.appService.getFlag('customTemplate');
    };
    TemplateComponent.prototype.allowChat = function () {
        return this.appService.getFlag('allowChat');
    };
    TemplateComponent.prototype.trackRouterChanges = function () {
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                if (window.innerWidth <= 991) {
                    window.scrollTo(0, 0);
                }
            }
        });
    };
    return TemplateComponent;
}());
export { TemplateComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/template.component.ts.pre-build-optimizer.js